// Dashboard Moderation platform health page translations (pt-BR), loaded into dashboard.moderation.health by ../pt-BR.moderation.js
module.exports = {
  // Words that make a report count as spam: the reason has one of them (any case, with or without accents); the
  // reports of "Outros motivos" count too; read by functions/src/dashboard/moderation/health.ts
  spamWords: ["spam", "ruim"],
  menu: "Saúde da Plataforma",
  title: "Saúde da Plataforma",
  description: "Moderação, segurança e qualidade da base.",
  links: {
    users: "Usuários reportados →",
    events: "Eventos reportados →",
  },
  kpis: {
    blocked: "Utilizadores bloqueados",
    reports: "Denúncias",
    aiFlagged: "Sinalizados pela IA",
    spam: "Spam",
    bans: "Banimentos",
    deleted: "Utilizadores excluídos",
    verified: "Utilizadores verificados",
    duplicates: "Contas duplicadas",
  },
  info: {
    blocked: "Utilizadores bloqueados por outros utilizadores, no último dia do período.\nFonte: Firebase (bloqueios entre utilizadores).",
    reports: "Denúncias de utilizadores e de eventos feitas no período.\nFonte: Firebase (denúncias).",
    aiFlagged: "Conteúdos sinalizados por moderação automática; as apps ainda não têm moderação por IA, por isso aparece n/d.\nFonte: sem fonte por agora.",
    spam: "Denúncias do período cujo motivo indica spam.\nFonte: Firebase (denúncias).",
    bans: "Contas bloqueadas pela administração, hoje (o bloqueio não tem data).\nFonte: Firebase (perfis dos utilizadores).",
    deleted: "Contas apagadas no período; as apagadas antes de a data passar a ser registada não contam.\nFonte: Firebase (perfis dos utilizadores).",
    verified: "Utilizadores verificados; as apps ainda não têm verificação, por isso aparece n/d.\nFonte: sem fonte por agora.",
    duplicates: "Contas criadas no período com um e-mail que outra conta já usava.\nFonte: Firebase (índice de e-mails das contas).",
  },
  hints: {
    bans: "contas bloqueadas pelo admin, hoje",
    duplicates: "mesmo email de outra conta",
    deletedSince: "contadas desde {date}",
  },
  unavailable: {
    aiFlagged: "a app ainda não tem sinalização por IA",
    verified: "a app ainda não tem verificação de utilizadores",
    deleted: "a data das exclusões passa a ser registada a partir de agora",
    deletedPanel: "A data das exclusões passa a ser registada a partir de agora; as exclusões anteriores não têm data.",
  },
  curation: {
    approved: "Aprovado",
    removed: "Removido",
    pending: "Em análise",
    sub: "denúncias",
  },
  reasons: {
    others: "Outros motivos",
  },
  panels: {
    signals: "Denúncias e sinalizações por {gran}",
    curation: "Decisão da curadoria",
    curationNote: "Estado das denúncias de utilizadores e eventos do período: aprovado quando a denúncia é rejeitada, removido quando é aceite.",
    reasons: "Motivos de denúncia",
    reasonsNote: "Texto escrito por quem denunciou: os 6 mais repetidos no período.",
    deleted: "Contas excluídas por {gran}",
  },
  panelInfo: {
    signals: "Denúncias de utilizadores e eventos em cada intervalo.\nFonte: Firebase (denúncias).",
    curation: "Estado das denúncias do período: aprovado, removido ou em análise.\nFonte: Firebase (denúncias).",
    reasons: "Motivos mais escritos nas denúncias do período.\nFonte: Firebase (denúncias).",
    deleted: "Contas apagadas em cada intervalo.\nFonte: Firebase (perfis dos utilizadores).",
  },
};
